export default __webpack_public_path__ + "static/7-f19fe8f4d25241ccc95e67b755fb61ba.jpg";